<template>
  <sliding-tabs
      v-if="isServiceProviderCatalogOccupationsLoaded"
      :activeTab="serviceProviderOccupationName"
      class="OCCUPATION-TABS">
    <template v-for="{ id, occupation } in serviceProviderCatalogOccupations">
      <sliding-tabs-content
          v-if="occupation.name"
          :key="occupation.name"
          :name="occupation.name"
          :titleProps="{
            title: occupation.display_name,
            to: {
              name: 'account::pro::occupation',
              params: { serviceProviderOccupationId: id }
            },
          }"
      />
    </template>
  </sliding-tabs>
</template>

<script>
import { mapGetters } from 'vuex';

import SlidingTabs from '@/components/SlidingTabs';
import SlidingTabsContent from '@/components/SlidingTabs/SlidingTabsContent';

export default {
  name: 'occupation-tabs',
  components: {
    SlidingTabs,
    SlidingTabsContent,
  },
  computed: {
    ...mapGetters('account/pro', [
      'serviceProviderCatalogOccupations',
    ]),
    serviceProviderOccupationId () {
      return parseInt(this.$route.params.serviceProviderOccupationId, 10);
    },
    serviceProviderOccupationName () {
      let name = '';

      if (!this.serviceProviderOccupationId) {
        return name;
      }

      const maybeOccupation = this.serviceProviderCatalogOccupations[
        this.serviceProviderOccupationId
      ];

      if (maybeOccupation) {
        // eslint-disable-next-line prefer-destructuring
        name = maybeOccupation.occupation.name;
      }

      return name;
    },
    isServiceProviderCatalogOccupationsLoaded () {
      return !!Object.keys(this.serviceProviderCatalogOccupations).length;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .OCCUPATION-TABS {
    @include margin-bottom(3, 4);
    height: 42px;
    display: flex;
    flex: 0 0 auto;
    border-bottom: 1px solid $color-gray30;
  }
</style>
